import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

var OptionalFieldset = (_param)=>{
    var { className , labels , active , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "active",
        "children"
    ]);
    return active ? /*#__PURE__*/ React.createElement("fieldset", swcHelpers.extends({}, rest, {
        className: classnames('optional-fieldset', className)
    }), /*#__PURE__*/ React.createElement("legend", {
        className: "optional-fieldset__legend"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        component: "h3"
    }, labels.legend)), /*#__PURE__*/ React.createElement("div", {
        className: "optional-fieldset__content"
    }, children)) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};

export { OptionalFieldset, OptionalFieldset as default };
//# sourceMappingURL=OptionalFieldset.js.map
